import { WSUser, WSResetUserPassword, WSRoles } from "features/users/models/users-models"
import { deleteRequest, getRequest, postRequest, putRequest, RequestDataType } from "../../../services/api"

export const getAllUsersAPI = async () => await getRequest("/UsersManagement")

export const getUserDetailsAPI = async (userId: string) => await getRequest(`/UsersManagement/${userId}`)

export const addUserAPI = async (data: Partial<WSUser>) => await postRequest("/UsersManagement", data, RequestDataType.Entity)

export const updateUserAPI = async (data: Partial<WSUser>) => await putRequest("/UsersManagement", data, RequestDataType.Entity)

export const deleteUserAPI = async (userId: string) => await deleteRequest("/UsersManagement", userId)

export const resetUserApiAsync = async (data: WSResetUserPassword) => await putRequest("/UsersManagement/ResetPassword", data, RequestDataType.Entity)

export const updateUserRolesAPIAsync = async (userId: string, roles: WSRoles[]) =>
    await putRequest(`/UsersManagement/${userId}/Roles`, roles, RequestDataType.Entity)

export const assignUserToCustomerAPIAsync = async (userId: string, customerId: string) =>
    await postRequest(`/UsersManagement/${userId}/assign-customer/${customerId}`, undefined, RequestDataType.Entity)

export const assignUserToSiteAPIAsync = async (userId: string, siteId: string) =>
    await postRequest(`/UsersManagement/${userId}/assign-site/${siteId}`, undefined, RequestDataType.Entity)

export const deleteUserPermissionAPIAsync = async (userId: string, permissionId: string) =>
    await deleteRequest(`/UsersManagement/${userId}/remove-permission/${permissionId}`, "");

